import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
    __pv_fired__?: boolean
  }
}

function initPixel() {
  if (window.fbq && window.fbq.loaded) return

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  let n: any
  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', '25735258989507271')
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()

    if (!window.__pv_fired__) {
      window.__pv_fired__ = true
      window.fbq('track', 'PageView')
    }
  }, [])
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Excedente Fantasma',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}
